import { useMutation, useQueryClient } from "@tanstack/react-query";

import { exploreImagesQueryKey } from "@/hooks/queries/useGetExploreImages";
import { guacHttpClient } from "@/lib/http";

export function useDeleteExploreImage() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await guacHttpClient.delete(`explore-images/${id}`);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: exploreImagesQueryKey });
    },
  });

  return mutation;
}
